module.exports = __webpack_public_path__ + "static/media/private-event01.ae87a274.jpg";